"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPerson = void 0;
const escape_1 = __importDefault(require("lodash/escape"));
const faMale_1 = require("@fortawesome/free-solid-svg-icons/faMale");
const faFemale_1 = require("@fortawesome/free-solid-svg-icons/faFemale");
const faChild_1 = require("@fortawesome/free-solid-svg-icons/faChild");
const faPortrait_1 = require("@fortawesome/free-solid-svg-icons/faPortrait");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
// FIXME This widget is custom because of the choices and validation string
exports.selectPerson = {
    type: 'question',
    path: '_activePersonId',
    twoColumns: false,
    sameLine: false,
    inputType: 'radio',
    datatype: 'string',
    containsHtml: true,
    label: (t) => t('selectPerson:_activePersonId'),
    choices: function (interview) {
        const persons = odSurveyHelper.getPersons({ interview });
        let personsRandomSequence = (0, helpers_1.getResponse)(interview, '_personRandomSequence');
        if (!Array.isArray(personsRandomSequence) || personsRandomSequence.length === 0) {
            console.error('No person random sequence found in interview to fill the select person widget. Will fallback to interviewable persons');
            const interviewablePersons = odSurveyHelper.getInterviewablePersonsArray({ interview });
            personsRandomSequence = interviewablePersons.map((person) => person._uuid);
        }
        return personsRandomSequence
            .map((personId, index) => {
            const person = persons[personId];
            if (!person) {
                console.error(`Person with ID ${personId} not found in interview. This should not happen, check the interview data.`);
                return null; // Skip this person if not found
            }
            let icon = faPortrait_1.faPortrait;
            if (person.age < 15) {
                icon = faChild_1.faChild;
            }
            else if (person.gender === 'male' ||
                ((0, LodashExtensions_1._isBlank)(person.gender) && person.sexAssignedAtBirth === 'male')) {
                icon = faMale_1.faMale;
            }
            else if (person.gender === 'female' ||
                ((0, LodashExtensions_1._isBlank)(person.gender) && person.sexAssignedAtBirth === 'female')) {
                icon = faFemale_1.faFemale;
            }
            const nickname = (0, escape_1.default)(person.nickname);
            return {
                value: person._uuid,
                label: {
                    fr: `<div style={{display: 'flex', alignItems: 'center', fontSize: '150%', fontWeight: 300}}><FontAwesomeIcon icon={icon} className="faIconLeft" style={{width: '4rem', height: '4rem'}} />Personne ${index + 1} • ${nickname} (${person.age} ans)</div>`,
                    en: `<div style={{display: 'flex', alignItems: 'center', fontSize: '150%', fontWeight: 300}}><FontAwesomeIcon icon={icon} className="faIconLeft" style={{width: '4rem', height: '4rem'}} />Person ${index + 1} • ${nickname} (${person.age} years old)</div>`
                }
            };
        })
            .filter((person) => person !== null); // Filter out any null values
    },
    validations: (value) => {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: {
                    fr: 'Veuillez sélectionner une personne pour poursuivre.',
                    en: 'Please select a person to continue.'
                }
            }
        ];
    }
};
